import { registerBlock } from "@smartfire/js-block-engine";

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
registerBlock("biscuits-list", () => import(/* webpackChunkName: "block-biscuits-list" */"./biscuits-list/block"));
registerBlock("decorative-list", () => import(/* webpackChunkName: "block-decorative-list" */"./decorative-list/block"));
registerBlock("decorative-list---item", () => import(/* webpackChunkName: "block-decorative-list---item" */"./decorative-list/item/block"));
registerBlock("footer", () => import(/* webpackChunkName: "block-footer" */"./footer/block"));
registerBlock("header", () => import(/* webpackChunkName: "block-header" */"./header/block"));
registerBlock("home-hero", () => import(/* webpackChunkName: "block-home-hero" */"./home-hero/block"));
